import { Component, EventEmitter, Output } from "@angular/core";
import { MessageService } from "primeng/api";
import { TranslocoService } from "@ngneat/transloco";
import { SocialService } from "src/app/service/social.service";

/**
 * Confirmação de bloqueio de uma pessoa, usada pelo perfil de usuário e pelo perfil de projeto
 * (onde bloqueia o dono). Explica o efeito antes de agir, mostra spinner enquanto a chamada roda e
 * emite `blocked` no sucesso para o pai decidir a navegação.
 */
@Component({
  selector: "app-social-block-dialog",
  templateUrl: "./social-block-dialog.component.html",
  styleUrls: ["./social-block-dialog.component.css"],
})
export class SocialBlockDialogComponent {
  visible = false;
  busy = false;
  targetUserId: string | null = null;
  targetName = "";

  @Output() blocked = new EventEmitter<string>();

  constructor(
    private social: SocialService,
    private messageService: MessageService,
    private translocoService: TranslocoService
  ) {}

  open(userId: string, displayName: string): void {
    this.targetUserId = userId;
    this.targetName = displayName;
    this.busy = false;
    this.visible = true;
  }

  cancel(): void {
    if (this.busy) return;
    this.visible = false;
  }

  confirm(): void {
    if (this.busy || !this.targetUserId) return;
    const userId = this.targetUserId;
    this.busy = true;
    this.social.blockUser(userId).subscribe({
      next: () => {
        this.busy = false;
        this.visible = false;
        this.messageService.add({ severity: "success", summary: this.translocoService.translate("socialFeed.blockDone") });
        this.blocked.emit(userId);
      },
      error: (err) => {
        this.busy = false;
        this.messageService.add({
          severity: "error",
          summary: this.translocoService.translate("socialFeed.blockUser"),
          detail: SocialService.parseHttpErrorMessage(err),
        });
      },
    });
  }
}
